import { Corn, getCornKernels } from '@eigtech/shared-corn'
import { ApiGetRequest, useApiInstanceContext, useQuery } from '@eigtech/ui-shared-api'
import { secondsToMilliseconds } from '@eigtech/ui-shared-dates'
import {
  GetNoteImportStatusRequest,
  GetNoteImportStatusResponse,
} from '@eigtech/verisk-edi-interface-types'
import { notebooksQueryKeys, veriskEdiBasePath } from './constants'

const getNoteImportStatus = (get: ApiGetRequest, params: GetNoteImportStatusRequest) =>
  get<GetNoteImportStatusResponse>(`${veriskEdiBasePath}/status/notes`, {
    searchParams: params,
  })

export function useGetNoteImportStatus(entityCorn: Corn) {
  const { get } = useApiInstanceContext()

  return useQuery({
    queryKey: notebooksQueryKeys.noteImportStatus(entityCorn),
    queryFn: () => getNoteImportStatus(get, { claimNumber: getCornKernels(entityCorn).resourceId }),
    refetchInterval: secondsToMilliseconds(60),
  })
}
